import React from 'react'

export default function CompanyForm() {
    return (
        <div className="flex w-full gap-2">
            <div className="w-3/5">
                <p className="flex  p-2 items-center">
                    <label className="w-2/5">
                        Bussiness Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="TMS "
                        required
                        className=" border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    />
                </p>
                <p className="flex p-2 items-center">
                    <label className="w-2/5">
                        Address 1
                    </label>
                    <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="231 N Tracy Blvd , Tracy CA 95376"
                        required
                        className="border border-customGray   hover:border-greenBg rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    />
                </p>
                <p className="flex  p-2 items-center">
                    <label className="w-2/5">
                        Address 2
                    </label>
                    <input
                        type="text"
                        name="address2"
                        id="address2"
                        required
                        className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    />
                </p>

                <p className="flex p-2 items-center">
                    <label className="w-2/5">
                        Phone Number
                    </label>
                    <input
                        type="number"
                        name="phone"
                        id="phone"
                        placeholder="209 310 0333"
                        required
                        className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    />
                </p>
                <p className="flex  p-2 items-center">
                    <label className="w-2/5">
                        Whats App Number
                    </label>
                    <input
                        type="number"
                        name="whatsapp"
                        id="whatsapp"
                        placeholder="209 310 0333"
                        required
                        className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    />
                </p>

                <p className=" p-2">
                    <label className="w-2/5">
                        Notes
                    </label>
                    <textarea
                        name="notes"
                        id="notes"
                        rows={5}
                        cols={20}
                        className="border border-customGray  hover:border-greenBg  rounded-lg bg-customGray w-full px-2 py-2 mt-4 ml-2 
                          focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                    ></textarea>
                </p>
            </div>
        </div>
    )
}
